import { InputNew } from "../../../../components/InputNew/InputNew";
import { Text } from "../../../../components/texts/text";
import { PaymentMorda } from "../../../payment-morda/ui/PaymentMorda/PaymentMorda";
import { CountChanger } from "./CountChanger/CountChanger";

import { useEffect, useRef, useState } from "react";
import InfoSVG from "../../../../assets/taiga-uikit/icons/info-circle.svg?react";
import MagicPenSVG from "../../../../assets/taiga-uikit/icons/magic-ai.svg?react";
import { Button } from "../../../../components/button/button";
import { _colorText, _sizeText, _style } from "../../../../core/core";
import { useOrder } from "../../../../entities/order/context/OrderContext";
import { useTokenLogin } from '../../../../entities/user/hooks/useTokenLogin';
import { Drawer, DrawerContent, DrawerHeader } from "../../../../shared/components/ui/drawer";
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../../shared/components/ui/tooltip';
import "./OrderCreateMorda.css";

export const OrderCreateMorda = () => {
    const { service, form } = useOrder()
    const { isAuthorized } = useTokenLogin();
    const inputEmailRef = useRef<HTMLInputElement>(null)
    const [isHoverEmail, setIsHoverEmail] = useState(false)

    useEffect(() => {
        const input = inputEmailRef.current;
        if (!input) return;

        const handleMouseEnter = () => setIsHoverEmail(true);
        const handleMouseLeave = () => setIsHoverEmail(false);

        input.addEventListener('mouseenter', handleMouseEnter);
        input.addEventListener('mouseleave', handleMouseLeave);

        return () => {
            input.removeEventListener('mouseenter', handleMouseEnter);
            input.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, [inputEmailRef]);
    const [isOpen, setIsOpen] = useState(false)
    if (!service) {
        return null
    }
    return (
        <PaymentMorda>
            <div className="order-create-morda">
                <InputNew
                    value={form.url}
                    onChange={(e) => form.setUrl(e.target.value)}
                    placeholder={`Ссылка на ${service.form_order.link_placeholder}`}
                    icon_right={<Button onClick={() => setIsOpen(true)} style={_style.flat}><InfoSVG /></Button>}
                    error={form.urlError}
                />
                <CountChanger
                    defaultCount={service.form_order.count_default}
                    steps={service.steps}
                    price_min={service.price_min}
                    price_max={service.price_max}
                />
                {isAuthorized ? (
                    <Tooltip open={isHoverEmail}>
                        <TooltipTrigger>
                            <InputNew
                                value={form.email} onChange={(e) => form.setEmail(e.target.value)}
                                placeholder="Почта"
                                disabled={isAuthorized}
                                error={form.emailError}
                                name="email"
                                autoComplete="email"
                                ref={inputEmailRef}
                                inputMode="email" />

                        </TooltipTrigger>
                        <TooltipContent>
                            <Text size={_sizeText.s} color={_colorText.default} style={{ zIndex: 10, padding: '4px' }}>
                                Вы авторизованы под этой почтой
                            </Text>
                        </TooltipContent>
                    </Tooltip>
                ) : (
                    <InputNew
                        value={form.email} onChange={(e) => form.setEmail(e.target.value)}
                        placeholder="Почта"
                        disabled={isAuthorized}
                        error={form.emailError}
                        name="email"
                        autoComplete="email"
                    />
                )}
                <InputNew
                    value={form.description}
                    onChange={(e) => form.setDescription(e.target.value)}
                    placeholder={service.form_order.comment_placeholder}
                    name="description"
                    autoComplete="off"
                />
                <div className="order-create-morda-magic-pen">
                    <MagicPenSVG />
                    <Text style={{ width: "100%" }}>{service.form_order.help_text}</Text>
                </div>
            </div>
            <>
                <Drawer open={isOpen} onOpenChange={setIsOpen} direction="bottom">
                    <DrawerContent className="flex items-center justify-center mt-2 drawer-link-main">
                        <div className="flex items-center justify-center drawer-link">
                            <DrawerHeader>
                                <Text size={_sizeText.xlb}>Какую ссылку вставлять?</Text>
                            </DrawerHeader>
                            <div className="flex flex-col gap-1">
                                <Text size={_sizeText.m}>Вставьте публичную ссылку на вашу компанию — ту, что открывается у всех пользователей, не из личного кабинета.</Text>

                                <Text size={_sizeText.m}>Убедитесь, что по ссылке видно:</Text>
                                <Text size={_sizeText.m}>– Название компании</Text>
                                <Text size={_sizeText.m}>– Отзывы (если они есть)</Text>

                                <Text size={_sizeText.m} color={_colorText.neutral}>Эта ссылка нужна нам, чтобы быстро проверять публикацию отзывов</Text>

                            </div>
                            <Button width={'100%'} onClick={() => setIsOpen(false)}>ОКАК</Button>
                        </div>
                    </DrawerContent>
                </Drawer>
            </>
        </PaymentMorda>
    )
}